var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.70833 1.60286H22.2917V22.1862H1.70833V1.60286ZM0.125 23.7695V0.0195312H23.875V23.7695H0.125ZM21.5 2.39453H12.7917V21.3945H21.5V2.39453ZM14.375 19.8112V3.97786H19.9167V19.8112H14.375ZM2.5 2.39453H11.2083V21.3945H2.5V2.39453ZM4.08333 3.97786V19.8112H9.625V3.97786H4.08333ZM4.875 8.72787H8.83333V7.14453H4.875V8.72787ZM15.1667 8.72787H19.125V7.14453H15.1667V8.72787ZM4.875 12.6862H8.83333V11.1029H4.875V12.6862ZM15.1667 12.6862H19.125V11.1029H15.1667V12.6862ZM4.875 16.6445H8.83333V15.0612H4.875V16.6445ZM15.1667 16.6445H19.125V15.0612H15.1667V16.6445Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRack);
export default __webpack_public_path__ + "static/media/rack.45a969b045e5905f0bb27b34c36c43fc.svg";
export { ForwardRef as ReactComponent };